module.exports = __webpack_public_path__ + "img/cases-brand-15.cba592aa.png";